export const WIDGET = 'widget';
export const ICE_BREAKER = 'iceBreaker';
export const TRIGGER = 'trigger';
export const BUTTON = 'button';
export const ENTRY = 'entry';
export const BOT = 'bot';
export const ENTRY_BUTTON = 'entry_button';
export const AUDIENCE = 'audience';
export const CONNECTION = 'connection';
export const PROMOTER = 'promoter';
export const COMPANY = 'company';
export const PLUGIN = 'plugin';
export const CONNECTED_PAGE = 'connectedPage';
export const CAMPAIGN = 'campaign';
